export const barChart1Option = {
    grid: {
        left: 80,
        right: 20,
        bottom: 120
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
            crossStyle: {
                color: '#999'
            }
        }
    },
    title: {
        text: 'DESAY SV ITMT WG ROADMAP 6 YEARS OVERVIEW',
        left: 'center',
        top: 15
    },
    legend: {
        data: ['2021', '2022', '2023', '2024', '2025', '2026'],
        bottom: 10
    },
    xAxis: {
        type: 'category',
        axisTick: {
            alignWithLabel: true,
        },
        axisLabel: {
            width: 100,
            rotate: 45,
            overflow: 'truncate'
        },
        data: ['Services and Application', 'software Architecture', 'Connectivity and BUS', 'PF & Control', 'Operating System', 'Cybersecurity&Safety', 'Electrical&Electronics', 'RF', 'Localization', 'Vision Display and Optics', 'Testing Technology', 'HMI', 'Sensors', 'Mechanics'],
        axisPointer: {
            type: 'shadow'
        }
    },
    yAxis: {
        type: 'value',
        min: 0
    },
    series: [
        {
            type: 'bar',
            name: '2021',
            data: [
                25, 7, 21, 18, 13, 7, 13, 6, 22, 21, 11, 6, 0, 3
            ]
        },
        {
            type: 'bar',
            name: '2022',
            data: [
                38, 7, 31, 29, 19, 28, 14, 7, 4, 31, 13, 10, 6, 12
            ]
        },
        {
            type: 'bar',
            name: '2023',
            data: [
                40.5, 7, 39, 26, 12, 27, 15, 13, 4, 39, 7, 11, 12, 11
            ]
        },
        {
            type: 'bar',
            name: '2024',
            data: [
                31, 3, 20, 10, 2, 10, 15, 9, 3, 20, 3, 4, 8, 0
            ]
        },
        {
            type: 'bar',
            name: '2025',
            data: [
                7, 0, 11, 10, 0, 4, 15, 12, 3, 11, 1, 1, 8, 0
            ]
        },
    ]
}

export const barChart2Option = {
    grid: {
        left: 80,
        right: 20,
        bottom: 120
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
            crossStyle: {
                color: '#999'
            }
        }
    },
    title: {
        text: 'DESAY SV ITMT PRIORITY OVERVIEW',
        left: 'center',
        top: 15
    },
    legend: {
        data: ['High', 'Mid', 'Low'],
        bottom: 10
    },
    xAxis: {
        type: 'category',
        axisTick: {
            alignWithLabel: true,
        },
        axisLabel: {
            width: 100,
            rotate: 45,
            overflow: 'truncate'
        },
        data: ['Services and Application', 'software Architecture', 'Connectivity and BUS', 'PF & Control', 'Operating System', 'Cybersecurity&Safety', 'Electrical&Electronics', 'RF', 'Localization', 'Vision Display and Optics', 'Testing Technology', 'HMI', 'Sensors', 'Mechanics'],
        axisPointer: {
            type: 'shadow'
        }
    },
    yAxis: {
        type: 'value',
        min: 0,
        max: 100,
        axisLabel: {
            formatter: '{value} %'
        }
    },
    series: [
        {
            type: 'bar',
            name: 'Low',
            stack: 'bar1',
            label: {
                show: true
            },
            barMaxWidth: 40,
            data: [
                29, 7, 24, 33, 10, 30, 7, 4, 32, 11, 12, 6, 2, 3
            ]
        },
        {
            type: 'bar',
            name: 'Mid',
            stack: 'bar1',
            label: {
                show: true
            },
            data: [
                13, 1, 47, 15, 6, 38, 7, 14, 4, 18, 5, 4, 12, 6
            ]
        },
        {
            type: 'bar',
            name: 'High',
            stack: 'bar1',
            label: {
                show: true
            },
            data: [
                3, 0, 8, 0, 4, 11, 1, 6, 0, 0, 0, 2, 5, 3
            ]
        },
    ]
}

export const barChart3Option = {
    grid: {
        left: 80,
        right: 20,
        bottom: 120
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
            crossStyle: {
                color: '#999'
            }
        }
    },
    color: ['#ffbb96', '#73d13d', '#4096ff', '#ff4d4f', '#531dab', '#ff85c0', '#fa8c16', '#0958d9', '#08979c', '#87e8de', '#b37feb', '#efdbff'],
    title: {
        text: 'DESAY SV TECHNOLOGY DEVELOPMENT STATUS OVERVIEW',
        left: 'center',
        top: 15
    },
    legend: {
        data: ['2021(On)', '2021(Plan)', '2022(On)', '2022(Plan)', '2023(On)', '2023(Plan)', '2024(On)', '2024(Plan)', '2025(On)', '2025(Plan)'],
        bottom: 10
    },
    xAxis: {
        type: 'category',
        axisTick: {
            alignWithLabel: true,
        },
        axisLabel: {
            width: 100,
            rotate: 45,
            overflow: 'truncate'
        },
        data: ['Services and Application', 'software Architecture', 'Connectivity and BUS', 'PF & Control', 'Operating System', 'Cybersecurity&Safety', 'Electrical&Electronics', 'RF', 'Localization', 'Vision Display and Optics', 'Testing Technology', 'HMI', 'Sensors', 'Mechanics'],
        axisPointer: {
            type: 'shadow'
        }
    },
    yAxis: {
        type: 'value',
        min: 0,
    },
    series: [
        {
            type: 'bar',
            name: '2021(On)',
            data: [
                25, 7, 21, 18, 13, 7, 13, 6, 22, 21, 11, 6, 0, 3
            ]
        },
        {
            type: 'bar',
            name: '2021(Plan)',
            data: [
                38, 7, 31, 29, 19, 28, 14, 7, 4, 31, 13, 10, 6, 12
            ]
        },
        {
            type: 'bar',
            name: '2022(On)',
            data: [
                40.5, 7, 39, 26, 12, 27, 15, 13, 4, 39, 7, 11, 12, 11
            ]
        },
        {
            type: 'bar',
            name: '2022(Plan)',
            data: [
                31, 3, 20, 10, 2, 10, 15, 9, 3, 20, 3, 4, 8, 0
            ]
        },
        {
            type: 'bar',
            name: '2023(On)',
            data: [
                7, 0, 11, 10, 0, 4, 15, 12, 3, 11, 1, 1, 8, 0
            ]
        },
        {
            type: 'bar',
            name: '2023(Plan)',
            data: [
                25, 7, 21, 18, 13, 7, 13, 6, 22, 21, 11, 6, 0, 3
            ]
        },
        {
            type: 'bar',
            name: '2024(On)',
            data: [
                38, 7, 31, 29, 19, 28, 14, 7, 4, 31, 13, 10, 6, 12
            ]
        },
        {
            type: 'bar',
            name: '2024(Plan)',
            data: [
                40.5, 7, 39, 26, 12, 27, 15, 13, 4, 39, 7, 11, 12, 11
            ]
        },
        {
            type: 'bar',
            name: '2025(On)',
            data: [
                31, 3, 20, 10, 2, 10, 15, 9, 3, 20, 3, 4, 8, 0
            ]
        },
        {
            type: 'bar',
            name: '2025(Plan)',
            data: [
                25, 7, 21, 18, 13, 7, 13, 6, 22, 21, 11, 6, 0, 3
            ]
        },
    ]
}

export const barChart4Option = {
    grid: {
        top: 80,
        left: 80,
        right: 20,
        bottom: 120
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
            crossStyle: {
                color: '#999'
            }
        }
    },
    title: {
        text: 'KEY TECHNOLOGY DEVELOPMENT STATUS',
        left: 'center',
        top: 15
    },
    legend: {
        data: ['DEVELOPING', 'RELEASED', 'PLANNING'],
        bottom: 10
    },
    xAxis: {
        type: 'category',
        axisTick: {
            alignWithLabel: true,
        },
        axisLabel: {
            width: 100,
            rotate: 45,
            overflow: 'truncate'
        },
        data: ['Services and Application', 'software Architecture', 'Connectivity and BUS', 'PF & Control', 'Operating System', 'Cybersecurity&Safety', 'Electrical&Electronics', 'RF', 'Localization', 'Vision Display and Optics', 'Testing Technology', 'HMI', 'Sensors', 'Mechanics'],
        axisPointer: {
            type: 'shadow'
        }
    },
    yAxis: {
        type: 'value',
        min: 0,
        max: 100,
        axisLabel: {
            formatter: '{value} %'
        }
    },
    series: [
        {
            type: 'bar',
            name: 'DEVELOPING',
            stack: 'bar1',
            label: {
                show: true
            },
            barMaxWidth: 40,
            data: [
                29, 7, 24, 33, 10, 30, 7, 4, 32, 11, 12, 6, 2, 3
            ]
        },
        {
            type: 'bar',
            name: 'RELEASED',
            stack: 'bar1',
            label: {
                show: true
            },
            data: [
                13, 1, 47, 15, 6, 38, 7, 14, 4, 18, 5, 4, 12, 6
            ]
        },
        {
            type: 'bar',
            name: 'PLANNING',
            stack: 'bar1',
            label: {
                show: true
            },
            data: [
                3, 0, 8, 0, 4, 11, 1, 6, 0, 0, 0, 2, 5, 3
            ]
        },
    ]
}

export const barChart5Option = {
    grid: {
        left: 80,
        right: 20,
        bottom: 120
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
            crossStyle: {
                color: '#999'
            }
        }
    },
    color: ['#5470c6', '#fac858'],
    title: {
        text: 'DESAY SV ITMT ACTIVITY YR 2021',
        left: 'center',
        top: 15
    },
    legend: {
        data: ['2021(On)', '2021(Plan)'],
        bottom: 10
    },
    xAxis: {
        type: 'category',
        axisTick: {
            alignWithLabel: true,
        },
        axisLabel: {
            width: 100,
            rotate: 45,
            overflow: 'truncate'
        },
        data: ['Services and Application', 'software Architecture', 'Connectivity and BUS', 'PF & Control', 'Operating System', 'Cybersecurity&Safety', 'Electrical&Electronics', 'RF', 'Localization', 'Vision Display and Optics', 'Testing Technology', 'HMI', 'Sensors', 'Mechanics'],
        axisPointer: {
            type: 'shadow'
        }
    },
    yAxis: {
        type: 'value',
        min: 0,
    },
    series: [
        {
            type: 'bar',
            name: '2021(On)',
            stack: 'bar1',
            label: {
                show: true
            },
            barMaxWidth: 40,
            data: [
                25, 7, 21, 18, 13, 7, 13, 6, 22, 21, 11, 6, 0, 3
            ]
        },
        {
            type: 'bar',
            name: '2021(Plan)',
            stack: 'bar1',
            label: {
                show: true
            },
            data: [
                38, 7, 31, 29, 19, 28, 14, 7, 4, 31, 13, 10, 6, 12
            ]
        },
    ]
}